import Roles from '@/shared/utils/roles.js'
import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'
import EmployeeRepository from '@/shared/http/repositories/configurations/employee'
import FormSearch from './search-form.js'

import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import BoardRepository from '@/shared/http/repositories/crm/board.js'
import PARepository from '@/shared/http/repositories/configurations/pa.js'
import RegionalRepository from '@/shared/http/repositories/configurations/regional.js'
import GroupRepository from '@/shared/http/repositories/configurations/group'
import AccountRepository from '@/shared/http/repositories/configurations/account.js'
import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import { JWTService } from '@/shared/services/jwt'

const DataSearch = {
  document: null,
  nome: null,
  numeroPA: null,
  nomeRegional: null,
  gerenteId: null,
  responsavelId: null,
  gruposResponsaveisId: null,
  origensId: null,
  quadrosId: null,
  produtosId: null,
  valorInicio: null,
  valorFinal: null,
  situacao: null,
  dataInicial: null,
  dataFinal: null
}

export default {
  name: 'ReportCardSearch',
  mixins: [ActionsForm],
  data () {
    return {
      data: DataSearch,
      form: FormSearch,
      roles: Roles,
      permissions: null,
      selected: 'gerente',
      showFilterSocialMedia: false,
      showFilterAssociado: false,
      showFilterInstituicao: true,
      showFilterResponsavel: false,
      showFilterCobranca: false,
      showFilterProduto: false,
      showFilterGeral: false
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  created () {
    this.onClear()
    this.permissions = JWTService.GetRoles()
    // this.onLoadEmployee()
    this.onLoadGroups()
    this.onLoadEmployeesFromUser()
    // this.onLoadUser()
    this.onLoadOrigins()
    this.onLoadBoards()
    this.onLoadProducts()
    this.onLoadPAs()
    this.onLoadRegionais()
  },
  methods: {
    onLoad () {
      this.onClearFilters()
      this.onCloseFilterAccordion()
    },
    hasRole (role) {
      var result = false
      if (this.permissions) {
        for (var i in this.permissions) {
          if (this.permissions[i] === role) {
            result = true
          }
        }
      }
      return result
    },
    onClearFilters () {
      Tools.ClearDataForms(this.form, this.data)
      this.form.valorInicial.value = 0
      this.form.valorFinal.value = 0
      this.form.employee.selected = []
      this.form.groups.selected = []
      this.form.responsible.selected = []
      this.form.groupResponsible.selected = []
      this.form.origin.selected = []
      this.form.board.selected = []
      this.form.product.selected = []
      this.form.situacao.selected = []
      this.parentComponent.filters = null
    },
    onCloseFilterAccordion () {
      this.showFilterSocialMedia = false
      this.showFilterAssociado = false
      this.showFilterInstituicao = false
      this.showFilterResponsavel = false
      this.showFilterCobranca = false
      this.showFilterProduto = false
      this.showFilterGeral = false
    },
    onFilter () {
      Tools.SetValueToSave(this.form, this.data)
      this.onGetEmployeeAndResponsibleAndGroup()
      if (this.validateFilter()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      } else {
        this.$eventHub.emit('Filter', { filters: null })
      }
    },
    validateFilter () {
      let result = true

      if (this.data) {
        this.data.numeroPA = this.data.numeroPA !== undefined && this.data.numeroPA ? this.data.numeroPA.toString() : null
        this.data.document = this.data.document ? this.data.document.toString().replace(/[^\d]+/g, '') : null
        this.data.valorInicio = this.data.valorInicio ? this.data.valorInicio.toString().replace('R$ ', '').replace('.', '').replace(',', '.') : null
        this.data.valorFinal = this.data.valorFinal ? this.data.valorFinal.toString().replace('R$ ', '').replace('.', '').replace(',', '.') : null
        this.data.valorInicio = this.data.valorInicio && this.data.valorInicio === '0.00' ? null : this.data.valorInicio
        this.data.valorFinal = this.data.valorFinal && this.data.valorFinal === '0.00' ? null : this.data.valorFinal
      }
      return result
    },
    mapSelectedValues (item) {
      if (!item) {
        return undefined
      }

      if (item.selected && item.selected.length > 0) {
        return item.selected.map(i => i.value)
      }

      if (item.value) {
        return item.value.value
      }

      return undefined
    },
    onGetEmployeeAndResponsibleAndGroup () {
      const fields = ['employee', 'responsible', 'groupResponsible', 'origin', 'board', 'product', 'situacao', 'numeroPA', 'nomeRegional']
      const keys = ['gerenteId', 'responsavelId', 'gruposResponsaveisId', 'origensId', 'quadrosId', 'produtosId', 'situacao', 'numeroPA', 'nomeRegional']

      fields.forEach((field, index) => {
        const selectedValues = this.mapSelectedValues(this.form[field])
        if (selectedValues !== undefined) {
          this.data[keys[index]] = selectedValues
        } else {
          this.data[keys[index]] = null
        }
      })
    },
    onLoadEmployee () {
      loading.push()
      EmployeeRepository.GetAll()
        .then((res) => {
          this.form.employee.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.pessoa.nome.toUpperCase()}))
          this.form.responsible.listOptions = res.data.content.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.pessoa.nome.toUpperCase()}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadGroups () {
      // loading.push()
      GroupRepository.GetAllActive()
        .then((res) => {
          this.form.groups.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup.toUpperCase()}))
          this.form.groupResponsible.listOptions = res.data.content.filter((x) => x.id != null).map((x) => ({'value': x.id, 'text': x.nameGroup.toUpperCase()}))
          loading.pop()
        })
    },
    onLoadEmployeesFromUser () {
      loading.push()
      if (this.hasRole(this.roles.ADMINISTRADOR)) {
        this.onLoadEmployee()
      } else {
        AccountRepository.GetAllFromUser()
          .then((res) => {
            loading.pop()
            this.form.employee.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.id, 'text': x.associado.pessoa.nome.toUpperCase()}))
            this.form.responsible.listOptions = res.data.filter((x) => x.usuarioId != null).map((x) => ({'value': x.usuarioId, 'text': x.associado.pessoa.nome.toUpperCase()}))
          })
          .catch(this.onException)
      }
    },
    onLoadUser () {
      loading.push()
      AccountRepository.GetAllKanbanUsers()
        .then((res) => {
          // this.form.responsible.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nomePessoa}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadOrigins () {
      loading.push()
      OriginRepository.GetAll()
        .then((res) => {
          this.form.origin.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome.toUpperCase()}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadBoards () {
      loading.push()
      BoardRepository.GetAll()
        .then((res) => {
          this.form.board.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome.toUpperCase()}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadProducts () {
      loading.push()
      ProductRepository.GetAll()
        .then((res) => {
          this.form.product.listOptions = res.data.content.map((x) => ({'value': x.id, 'text': x.nome.toUpperCase()}))
          loading.pop()
        })
        .catch(this.onException)
    },
    onLoadPAs () {
      PARepository.GetAll()
        .then((response) => {
          let result = response.data.content
            .map((x) => ({'value': x.numero, 'text': x.descricao}))
          this.form.numeroPA.listOptions = result
        })
        .catch(this.onException)
    },
    onLoadRegionais () {
      RegionalRepository.GetAll()
        .then((response) => {
          // CURRENTLY BEEN SET VALUE=NOME UNTIL BACKEND ACCEPTS MULTIPLE
          let result = response.data.content
            .map((x) => ({'value': x.nome, 'text': x.nome}))
          this.form.nomeRegional.listOptions = result
        })
        .catch(this.onException)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/reports/crm/search/search.js